export default "__VITE_ASSET__0d26fa38__"